import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import Dashboard from './components/dashboard/Dashboard'
import Orders from './components/dashboard/Orders'




class App extends Component {

  /*
  componentDidMount(){
    const messaging = firebase.messaging()
    messaging.requestPermission().then(()=>{
      return messaging.getToken()
    }).then(token=>{
      console.log('Token : ',token)
    }).catch((err)=>{
      console.log(err);
      
    })
    messaging.onMessage((payload)=>{
      console.log('onMessage : ', payload);
    })
    //navigator.serviceWorker.addEventListener("message", (message) => console.log(message));
  }*/

  render() {
    return (
      <BrowserRouter>
        <div>
          <Switch>
            <Route exact path='/' component={Dashboard} />
            <Route exact path='/admin/order' component={Orders} />
          </Switch>

          {  /* <Footer/>  */}
        </div>
      </BrowserRouter>

    );
  }
}

export default App;
